const RELOAD_KEY = "chunk-reload"

import type { Component } from "vue"

export function lazyImport(importFn: () => Promise<{ default: Component }>) {
  return async () => {
    try {
      return await importFn()
    } catch (error) {
      if (!hasChunkReloadFlag()) {
        sessionStorage.setItem(RELOAD_KEY, "1")
        window.location.reload()
        return
      }
      throw error
    }
  }
}

export function hasChunkReloadFlag(): boolean {
  return sessionStorage.getItem(RELOAD_KEY) === "1"
}

export function clearChunkReloadFlag() {
  sessionStorage.removeItem(RELOAD_KEY)
}
